import { Hub } from "./hub";

export type TListener<T> = (data:T | null) => void

export class TableHub<T>  {
    #url: string 
    #hubs: Map<string, Hub<T>>

    constructor(url: string) {
        this.#url = url
        this.#hubs = new Map<string, Hub<T>>()
    }

    get(id:string): Hub<T> | undefined {
        if(!this.#hubs.has(id)) {
            let hub = new Hub<T>(this.#url.replace('{id}', id))
            this.#hubs.set(id, hub)
            return hub
        }
        return this.#hubs.get(id)
    }

}